import React from 'react';
import Section from './layouts/Section';
import BlogArea from './layouts/BlogArea';
import PageLayout from './layouts/PageLayout';

const Blog = () => {
  return (
    <PageLayout title="Cell Station – Blog | Expert Cellphone Repair">
      <Section title="Blog">
        <BlogArea />
      </Section>
    </PageLayout>
  );
};

export default Blog;
